import {
  Mail,
  MapPin,
  Calendar,
  UserRound,
  Warehouse,
  IdCard,
  FileLock2,
  ScanQrCode,
  Phone,
} from "lucide-react";
import { Divider } from "antd";
import { formatDate } from "../../utils/dateTime";

const EmployeeCard = ({ employee }) => {
  const getInitials = (firstName, lastName) => {
    return `${firstName?.charAt(0) || ''}${lastName?.charAt(0) || ''}`.toUpperCase();
  };
  
  return (
    <div className="w-full flex flex-col gap-1 rounded-lg border-2 border-t-[#231564] border-form-bg shadow-lg px-2 py-2 bg-white relative overflow-hidden">
      <div className="flex items-center gap-2 text-gray-700 font-semibold">
        <UserRound className="h-5 w-5" />
        <h2 className="text-md font-semibold pt-2">PROFILE</h2>
      </div>
      <Divider className="!p-0 !m-0" />
      <div className="relative flex flex-col items-center text-center mb-1">
        <div className="shadow-lg w-full h-24 sm:h-36 rounded-xl flex items-center justify-center bg-gradient-to-r from-[#231564] to-[#5947ad]">
          {employee.image ? (
            <img 
              className="h-16 w-16 sm:h-20 sm:w-20 rounded-full object-cover" 
              src={employee.image} 
              alt={`${employee.firstName} ${employee.lastName}`}
            />
          ) : (
            <div className="h-16 w-16 sm:h-20 sm:w-20 rounded-full bg-white flex items-center justify-center text-[#231564] font-bold text-xl sm:text-2xl">
              {getInitials(employee.firstName, employee.lastName)}
            </div>
          )}
        </div>
      </div>
      <div className="flex items-center justify-between sm:gap-20 w-full mt-5">
        <span className="text-sm sm:text-md text-gray-400 font-normal">EMPLOYEE CODE</span>
        <span className="text-sm sm:text-md font-semibold text-center">{employee.employee_code}</span>
      </div>
      <h3 className="text-sm sm:text-md font-bold mt-1 text-center">{`${employee.firstName} ${employee.lastName}`}</h3>
      <div className="mt-2 space-y-2 text-sm sm:text-md mt-5">
        <div className="flex justify-between items-center text-gray-400 pb-2">
          <div className="flex flex-col">
            <span className="text-gray-400 text-sm sm:text-md font-normal">ADDRESS</span>
            <span className="font-normal text-black truncate max-w-[200px] sm:max-w-none">
              {`${employee.permanent_address}, ${employee.city}, ${employee.country}`}
            </span>
          </div>
          
          <div className="border px-1 py-1 flex items-center justify-center rounded-md border-gray-400">
            <MapPin size={12} className="text-gray-400" />
          </div>
        </div>
        <div className="flex justify-between items-center text-gray-400 pb-2">
          <div className="flex flex-col">
            <span className="text-gray-400 text-sm sm:text-md font-normal">EMAIL</span>
            <span className="font-normal truncate text-black max-w-[200px] sm:max-w-none">
              {employee.emailAddress}
            </span>
          </div>
          <div className="border px-1 py-1 flex items-center justify-center rounded-md border-gray-400">
            <Mail size={12} className="text-gray-400" />
          </div>
        </div>
        <div className="flex justify-between items-center text-gray-400 pb-2">
          <span className="text-gray-400 font-normal">DOB</span>
          <span className="font-normal">{formatDate(employee.dob)}</span>
          <div className="border px-1 py-1 flex items-center justify-center rounded-md border-gray-400">
            <Calendar size={12} className="text-gray-400" />
          </div>
        </div>
        <div className="flex justify-between items-center text-gray-400 pb-2">
          <div className="flex flex-col">
            <span className="text-gray-400 text-sm sm:text-md font-normal">MARITAL STATUS</span>
            <span className="font-normal truncate text-black max-w-[200px] sm:max-w-none">
              {employee.maritalStatus || "Not Specified"}
            </span>
          </div>
          <div className="border px-1 py-1 flex items-center justify-center rounded-md border-gray-400">
            <Warehouse size={12} className="text-gray-400" />
          </div>
        </div>
        <Divider className="!p-0 !m-0 my-1" />
        <div className="flex justify-between items-center text-gray-400 pb-2 mt-2">
          <span className="text-gray-400 font-normal">NATIONAL ID</span>
          <span className="font-normal">{employee.nationalId || "Not Specified"}</span>
          <div className="border px-1 py-1 flex items-center justify-center rounded-md border-gray-400">
            <IdCard size={12} className="text-gray-400" />
          </div>
        </div>
        <div className="flex justify-between items-center text-gray-400 pb-2">
          <span className="text-gray-400 font-normal">PASSPORT NO</span>
          <span className="font-normal">{employee.passportNo || "Not Specified"}</span>
          <div className="border px-1 py-1 flex items-center justify-center rounded-md border-gray-400">
            <FileLock2 size={12} className="text-gray-400" />
          </div>
        </div>
        <div className="flex justify-between items-center text-gray-400 pb-2">
          <div className="flex flex-col">
            <span className="text-gray-400 text-sm sm:text-md font-normal">MACHINE CODE</span>
            <span className="font-normal truncate text-black max-w-[200px] sm:max-w-none">
              {employee.machineCode}
            </span>
          </div>
          <div className="border px-1 py-1 flex items-center justify-center rounded-md border-gray-400">
            <ScanQrCode size={12} className="text-gray-400" />
          </div>
        </div>
        <Divider className="!p-0 !m-0 my-1" />
        <div className="flex justify-between items-center text-gray-400 pb-2 mt-5">
          <div className="flex flex-col">
            <span className="text-gray-400 text-sm sm:text-md font-normal">TEMPORARY ADDRESS</span>
            <span className="font-normal truncate text-black max-w-[200px] sm:max-w-none">
              {employee.temporary_address || 'N/A'}
            </span>
          </div>
          
          <div className="border px-1 py-1 flex items-center justify-center rounded-md border-gray-400">
            <MapPin size={12} className="text-gray-400" />
          </div>
        </div>
        <div className="flex justify-between items-center text-gray-400 pb-2">
          <div className="flex flex-col">
            <span className="text-gray-400 text-sm sm:text-md font-normal">PERMANENT ADDRESS</span>
            <span className="font-normal truncate text-black max-w-[200px] sm:max-w-none">
              {employee.permanent_address || 'N/A'}
            </span>
          </div>
          
          <div className="border px-1 py-1 flex items-center justify-center rounded-md border-gray-400">
            <MapPin size={12} className="text-gray-400" />
          </div>
        </div>
        <div className="flex justify-between items-center text-gray-400 pb-2">
          <span className="text-gray-400 font-normal">NATIONALITY</span>
          <span className="font-normal">{employee.nationality || "Not Specified"}</span>
          <div className="border px-1 py-1 flex items-center justify-center rounded-md border-gray-400">
            <IdCard size={12} className="text-gray-400" />
          </div>
        </div>
        <Divider className="!p-0 !m-0" />
        <div className="flex justify-between items-center text-gray-400 mt-2">
          <span className="text-gray-400 font-normal">PHONE</span>
          <span className="font-normal">{employee.contact_number}</span>
          <div className="border px-1 py-1 flex items-center justify-center rounded-md border-gray-400">
            <Phone size={12} className="text-gray-400" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeCard;
